import axios from "axios";

export const api = axios.create({
    baseURL: "https://vimentis.ch/wp-json/vimentis-wahlentool/v1"
});